import React from "react";
// Components
import Table from "./../../../../components/Table/Table";
import { MacEsResult } from "../Result/MacEs";

// Helpers
import { utils } from "./../../../../helpers";
import { __ } from "@wordpress/i18n";

/** Constants for reusable values */
const CLASSES = {
    TEXT_LEFT: "text-left",
    TEXT_LEFT_BOLD: "text-left bold",
};

/** Strings with i18n */
const LABELS = {
    headers: {
        empty: " ",
        prudente: __("Prudente", "df-simulators"),
        ampliado: __("Ampliado", "df-simulators"),
    } as Record<string, string>,
    data: {
        effortRate: __("Taxa de esforço", "df-simulators"),
        equityDownAmount: __("Capitais próprios", "df-simulators"),
        loanAmount: __("Valor do empréstimo", "df-simulators"),
        propertyValue: __("Valor do imóvel", "df-simulators"),
        paymentValue: __("Valor da prestação", "df-simulators"),
    },
};

interface TabComparisonProps {
    simulationData: MacEsResult;
}

/** Component */
const TabComparison: React.FC<TabComparisonProps> = ({ simulationData }) => {
    const headers = [
        {
            value: LABELS.headers.empty,
            className: CLASSES.TEXT_LEFT,
        },
    ];

    const data = [
        [{ value: LABELS.data.effortRate, className: CLASSES.TEXT_LEFT }],
        [{ value: LABELS.data.equityDownAmount, className: CLASSES.TEXT_LEFT }],
        [{ value: LABELS.data.loanAmount, className: CLASSES.TEXT_LEFT }],
        [{ value: LABELS.data.propertyValue, className: CLASSES.TEXT_LEFT_BOLD }],
        [{ value: LABELS.data.paymentValue, className: CLASSES.TEXT_LEFT }],
    ];

    Object.entries(simulationData).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        headers.push({
            value: LABELS.headers[key],
            className: CLASSES.TEXT_LEFT,
        });

        const effortRateRounded = Math.round(value.results.paymentValue.dstiRatio.achieved * 100);
        data[0].push({
            value:
                (key === "prudente" ? '<i class="icon icon-check"></i>' : '<i class="icon icon-exclamation"></i>') +
                effortRateRounded.toString() +
                "%",
            className: CLASSES.TEXT_LEFT,
        });
        data[1].push({
            value: utils.toEuro(value.results.equityDownAmount),
            className: CLASSES.TEXT_LEFT,
        });
        data[2].push({
            value: utils.toEuro(value.results.loanAmount),
            className: CLASSES.TEXT_LEFT,
        });
        data[3].push({
            value: utils.toEuro(value.results.propertyValue),
            className: CLASSES.TEXT_LEFT_BOLD,
        });
        data[4].push({
            value: utils.toEuro(value.results.paymentValue.paymentValue),
            className: CLASSES.TEXT_LEFT,
        });
    });

    return simulationData && <Table headers={headers} data={data} />;
};

export default TabComparison;
